"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSTSchema = exports.SSTBaseSchema = exports.SSTDetailedSchema = exports.ResponsiblePersonSchema = exports.VesselSchema = exports.SeafarerSchema = exports.SSTDisplay = exports.SSTDisplaySchema = exports.SSTExclusionSchema = exports.SSTDashboardDTO = exports.SSTDashboardDTOSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var SSTDashboardSchema = zod_1.z.object({
    position: zod_1.z.string().nullish(),
    yacthName: zod_1.z.string().nullish(),
    issuedOn: zod_1.z.coerce.date().nullish(),
});
exports.SSTDashboardDTOSchema = zod_1.z
    .object({
    createdAt: zod_1.z.coerce.date(),
    _id: zod_1.z.coerce.string(),
})
    .merge(SSTDashboardSchema);
exports.SSTDashboardDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            issuedOn: model.dateFrom,
            createdAt: model.createdAt,
            position: model.seafarer.position,
            yacthName: model.vessel.name,
        };
        return dto;
    },
};
exports.SSTExclusionSchema = zod_1.z.object({
    reason: zod_1.z.string(),
    fullName: zod_1.z.string(),
    dateExcluded: zod_1.z.date(),
});
exports.SSTDisplaySchema = zod_1.z
    .object({
    _id: zod_1.z.string(),
    yacthType: zod_1.z.string().nullish(),
    yacthLength: zod_1.z.number().nullish(),
    // expiry: z.coerce.date().nullish(),
    dateTo: zod_1.z.coerce.date().nullish(),
    dateFrom: zod_1.z.coerce.date().nullish(),
    status: zod_1.z.string().nullish(),
    // NCap SSTs
    ncapSSTID: zod_1.z.string().nullish(),
    // SSTs from Satori
    UploadUrl: zod_1.z.string().nullish(),
    Notes: zod_1.z.string().nullish(),
    uid: zod_1.z.string().nullish(),
    // PMM-614
    exclusion: exports.SSTExclusionSchema.optional().nullish(),
})
    .merge(SSTDashboardSchema);
exports.SSTDisplay = {
    convertFromModel: function (model) {
        var _a;
        var dto = {
            _id: model._id.toString(),
            // issuedOn: model.dateFrom,
            dateFrom: model.dateFrom,
            // expiry: model.dateTo,
            dateTo: model.dateTo,
            // Return capacity if present, else position
            position: model.seafarer.capacity || model.seafarer.position,
            yacthLength: model.vessel.length,
            yacthName: model.vessel.name,
            yacthType: model.vessel.vesselType,
            UploadUrl: model.UploadUrl,
            status: model.status,
            uid: model.uid,
            exclusion: model.exclusionReason
                ? {
                    reason: model.exclusionReason,
                    // @ts-expect-error This is populated
                    fullName: ((_a = model.exclusionUserId) === null || _a === void 0 ? void 0 : _a.fullName) || 'Admin',
                    dateExcluded: model.updatedAt,
                }
                : null,
        };
        return dto;
    },
};
exports.SeafarerSchema = zod_1.z.object({
    firstName: zod_1.z.string().nullish(), // FROM MMS
    middleName: zod_1.z.string().nullish(), // FROM MMS
    lastName: zod_1.z.string().nullish(), // FROM MMS
    email: zod_1.z.string().nullish(), // FROM MMS
    dateOfBirth: zod_1.z.string().nullish(), // FROM MMS
    capacity: zod_1.z.string().nullish(),
    phoneNumber: zod_1.z.string().nullish(), // FROM MMS
    pyaMembershipNo: zod_1.z.string().nullish(), // FROM MMS
    cocNo: zod_1.z.string().nullish(),
    cocAuthority: zod_1.z.string().nullish(),
    position: zod_1.z.string().nullish(), // FROM MMS
    orgAndAddress: zod_1.z.string().nullish(),
    verified: zod_1.z.boolean().nullish(),
    firebaseProfileUid: zod_1.z.string().nullish(),
});
exports.VesselSchema = zod_1.z.object({
    vesselType: zod_1.z.string().nullish(), // YachtType
    name: zod_1.z.string().nullish(), // YachtName
    flag: zod_1.z.string().nullish(), // YachtFlag
    officialNumber: zod_1.z.string().nullish(), // ON
    imoNumber: zod_1.z.string().nullish(),
    length: zod_1.z.coerce.number().nullish(), // Length
    grossTonnage: zod_1.z.coerce.number().nullish(), // GT
    mainEngineType: zod_1.z.string().nullish(),
    mainEnginePower: zod_1.z.string().nullish(),
    kw: zod_1.z.coerce.number().nullish(), // This one comes from Satori alone it seems.
});
exports.ResponsiblePersonSchema = zod_1.z.object({
    // SignedByTitle
    firstName: zod_1.z.string().nullish(),
    middleName: zod_1.z.string().nullish(),
    lastName: zod_1.z.string().nullish(), // SignedByName
    email: zod_1.z.string().nullish(),
    dateOfBirth: zod_1.z.string().nullish(),
    capacity: zod_1.z.string().nullish(), // SignedByCapacity
    phoneNumber: zod_1.z.string().nullish(),
    pyaMembershipNo: zod_1.z.string().nullish(),
    cocNo: zod_1.z.string().nullish(), // CocNo
    cocAuthority: zod_1.z.string().nullish(), // CoCIssuedBy
    cocStatus: zod_1.z.string().nullish(),
    position: zod_1.z.string().nullish(), // SignedByCapacity MAYBE
    orgAndAddress: zod_1.z.string().nullish(),
    yachtName: zod_1.z.string().nullish(), // YachtName
    approvedSSTs: zod_1.z.number().nullish(), // ?
    pyaMembershipNumber: zod_1.z.string().nullish(), // IF IN MMS, then it's easier.
});
exports.SSTDetailedSchema = zod_1.z.object({
    testimonialType: zod_1.z.string().nullish(), // TestimonialType
    status: zod_1.z.string().nullish(), //READY
    dateFrom: zod_1.z.coerce.date().nullish(), //READY
    dateTo: zod_1.z.coerce.date().nullish(), //READY
    actualDays: zod_1.z.number().nullish(), // ActualSeaService
    nauticalMiles: zod_1.z.number().nullish(), // NauticalMiles
    daysGuests: zod_1.z.number().nullish(), // DaysWithGuestsOnBoard
    daysStandBy: zod_1.z.number().nullish(), // StandByService
    daysShipyard: zod_1.z.number().nullish(), // YardService
    daysWatchKeeping: zod_1.z.number().nullish(), // DeckWatch
    daysSeagoingWatchKeeping: zod_1.z.number().nullish(), // EngineeringWatch
    daysAdditionalWatchKeeping: zod_1.z.number().nullish(), // AdditionalEngineeringWatch
    nightWatchHours: zod_1.z.number().nullish(),
    daysLeave: zod_1.z.number().nullish(), // SUM OF LEAVE DATES
    totalDays: zod_1.z.number().nullish(), // SUM OF THE OTHER DAYS
    // LoADates
    leaveDates: zod_1.z.array(zod_1.z
        .object({
        from: zod_1.z.coerce.date(),
        to: zod_1.z.coerce.date(),
    })
        .nullish()),
    rotationProgram: zod_1.z.string().nullish(), // ?
    areasCruised: zod_1.z.array(zod_1.z.string()).nullish(), // AreasSailed
    rejectionReason: zod_1.z.string().nullish(), // ?
    certificateId: zod_1.z.string().nullish(), // ?
    additionalInformation: zod_1.z.string().nullish(), // ?
    seafarer: exports.SeafarerSchema,
    vessel: exports.VesselSchema,
    responsiblePerson: exports.ResponsiblePersonSchema,
});
exports.SSTBaseSchema = zod_1.z
    .object({
    UserId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    // Satori Exclusive Fields
    UploadUrl: zod_1.z.string().nullish(), // FileName
    Notes: zod_1.z.string().nullish(), // Notes
    Comments: zod_1.z.string().nullish(),
    SignedByTitle: zod_1.z.string().nullish(),
    //NCap Specific Field
    uid: zod_1.z.string().nullish(),
    // PMM-614
    exclusionReason: zod_1.z.string().nullish(),
    exclusionUserId: zod_1.z.instanceof(ObjectId_1.ObjectId).nullish(),
})
    .merge(exports.SSTDetailedSchema);
exports.SSTSchema = exports.SSTBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
//# sourceMappingURL=SST.js.map